import { render } from "./CandidateCertificationsTab.vue?vue&type=template&id=f017d024"
import script from "./CandidateCertificationsTab.vue?vue&type=script&lang=js"
export * from "./CandidateCertificationsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__